import axios from "axios"
import Vue from "vue"
import store from '@/store/index.js'

// 创建axios实例
const instance = axios.create({
  baseURL: process.env.BASE_URL, //通用请求的地址前缀,有自己后端的话就换成自己后端服务的前缀
  timeout: 10000, //限制请求超时时间
  // headers: {
  //   token: store.getters.token
  // },
})

// 添加请求拦截器（axios拦截器）
instance.interceptors.request.use(function (config) {
    config.headers.token=store.state.token
    // 在发送请求之前做些什么
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.resolve({code: 0, msg: error})
  })

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  if(response.status != 200) {
    return Promise.resolve({code: 0, msg: "网络异常"})
  }

  switch(response.data.code) {
    case 1:
      break;
    case 10001:
      store.commit('setDialogLogin', true)
      break;
    default:
      Vue.prototype.$message({showClose: true, message: response.data.msg, type: 'error'})
      break;
  }

  return Promise.resolve(response.data)
  }, function (error) {
    // 对响应错误做点什么
    return Promise.resolve({code: 0, msg: error})
  })

export default instance



// WEBPACK FOOTER //
// ./src/common/request.js